import { Controller } from "stimulus";
import Swal from "sweetalert2";

export default class extends Controller {
  onCancel = () => {
    Swal.close();
  };
}
